'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _shipping_template_form = require('../components/shipping_template_form');

var _shipping_template_form2 = _interopRequireDefault(_shipping_template_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShippingTemplateEdit = _react2.default.createClass({
    displayName: 'ShippingTemplateEdit',
    render: function render() {
        var _props = this.props,
            shippingTemplates = _props.shippingTemplates,
            params = _props.params;

        var shippingTemplate = shippingTemplates.filter(function (o) {
            return o.id == params.shippingTemplateID;
        })[0];
        return _react2.default.createElement(
            'div',
            { id: 'shipping-template-edit' },
            _react2.default.createElement(_shipping_template_form2.default, { shippingTemplate: shippingTemplate })
        );
    }
});

var mapStateToProps = function mapStateToProps(store) {
    var shippingTemplates = store.shippingTemplate.shippingTemplates;

    return {
        shippingTemplates: shippingTemplates.items
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ShippingTemplateEdit);


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/shipping_template_edit.js
// module id = 1548
// module chunks = 0